/**
 * A/B Test: PDP gallery first image + pack accordion (summer offer)
 *
 * Products: /products/rasoir-elios-1, /products/rasoir-5-en-1
 *
 * body attribute (IntelliGems / AB tool):
 *   data-elios-gallery-image-test="true"  → offer gallery image +
 *                                          "Que contient le pack Elios ?" first & open
 *   data-elios-gallery-image-test="false" → default gallery image + default accordion order
 *
 * Dev preview: ?gallery_image_test=b  (or true / 1)
 *
 * Image URL is set from Liquid:
 *   window.__eliosGalleryImageAB = { imageUrl: "..." }
 */
(function () {
  'use strict';

  if (window.__eliosGalleryImageABTestInit) return;
  window.__eliosGalleryImageABTestInit = true;

  var BODY_ATTR = 'data-elios-gallery-image-test';
  var ACTIVE_CLASS = 'elios-gallery-image-test-b';
  var MARK_ATTR = 'data-elios-gallery-image-swapped';
  var ORIG_SRC_ATTR = 'data-elios-gallery-orig-src';
  var ORIG_SRCSET_ATTR = 'data-elios-gallery-orig-srcset';
  var ORIG_SIZES_ATTR = 'data-elios-gallery-orig-sizes';
  var ORIG_POS_ATTR = 'data-elios-gallery-orig-pos';
  var ORIG_BEFORE_ATTR = 'data-elios-gallery-orig-before';
  var ORIG_AFTER_ATTR = 'data-elios-gallery-orig-after';
  var ACCORDION_MOVED_ATTR = 'data-elios-gallery-accordion-moved';
  var ALLOWED_PRODUCT_HANDLES = ['rasoir-elios-1', 'rasoir-5-en-1'];
  var ALT_TEXT = 'Offre spéciale été — Rasoir ELIOS®';
  var PACK_TITLE_RE = /que\s+contient\s+le\s+pack\s+elios/i;
  // Apostrophe variants: ' ' ’
  var WHAT_IS_TITLE_RE = /qu['\u2019\u02bc]est\s+ce\s+que\s+elios/i;

  var applying = false;
  var pendingApply = false;
  var debounceTimer = null;
  var pollTimer = null;
  var verifyTimer = null;
  var offerPreloadStarted = false;

  function getConfigImageUrl() {
    var cfg = window.__eliosGalleryImageAB;
    if (cfg && cfg.imageUrl) return String(cfg.imageUrl);
    return '';
  }

  function normalizeUrl(url) {
    if (!url) return '';
    try {
      var u = String(url).split('?')[0].split('#')[0];
      return u.replace(/\/$/, '').toLowerCase();
    } catch (e) {
      return String(url || '');
    }
  }

  function urlsMatch(a, b) {
    if (!a || !b) return false;
    if (a === b) return true;
    return normalizeUrl(a) === normalizeUrl(b);
  }

  function preloadOfferImage(url) {
    if (!url || offerPreloadStarted) return;
    offerPreloadStarted = true;
    try {
      var img = new Image();
      img.decoding = 'async';
      img.src = url;
    } catch (e) {}
  }

  function normalizeHandle(value) {
    if (!value) return '';
    try {
      value = decodeURIComponent(String(value));
    } catch (e) {}
    return value
      .toLowerCase()
      .replace(/^\/+|\/+$/g, '')
      .replace(/®/g, '')
      .replace(/[^a-z0-9-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function getCurrentProductHandle() {
    try {
      var path = window.location.pathname || '';
      var match = path.match(/\/products\/([^/?#]+)/i);
      if (match && match[1]) return normalizeHandle(match[1]);
    } catch (e) {}

    var meta = document.querySelector('meta[property="og:url"], link[rel="canonical"]');
    if (meta) {
      var href = meta.getAttribute('content') || meta.getAttribute('href') || '';
      var matchMeta = href.match(/\/products\/([^/?#]+)/i);
      if (matchMeta && matchMeta[1]) return normalizeHandle(matchMeta[1]);
    }

    return '';
  }

  function isAllowedProductPage() {
    var handle = getCurrentProductHandle();
    if (!handle) return false;
    for (var i = 0; i < ALLOWED_PRODUCT_HANDLES.length; i++) {
      if (handle === ALLOWED_PRODUCT_HANDLES[i]) return true;
    }
    return false;
  }

  function isDevVariant() {
    try {
      var q = new URLSearchParams(window.location.search).get('gallery_image_test');
      if (!q) return false;
      q = String(q).toLowerCase();
      return q === 'b' || q === 'true' || q === '1' || q === 'on';
    } catch (e) {
      return false;
    }
  }

  function getBodyAttr() {
    if (document.body && document.body.hasAttribute(BODY_ATTR)) {
      return document.body.getAttribute(BODY_ATTR);
    }
    if (document.documentElement && document.documentElement.hasAttribute(BODY_ATTR)) {
      return document.documentElement.getAttribute(BODY_ATTR);
    }
    return null;
  }

  function isTruthy(value) {
    var normalized = String(value || '')
      .trim()
      .toLowerCase();
    return normalized === 'true' || normalized === '1' || normalized === 'on' || normalized === 'yes';
  }

  /** true → summer offer active */
  function isSummerOfferActive() {
    if (isDevVariant()) return true;
    if (document.body && document.body.classList.contains(ACTIVE_CLASS)) return true;
    return isTruthy(getBodyAttr());
  }

  function rememberOriginal(img) {
    if (!img || img.hasAttribute(ORIG_SRC_ATTR)) return;
    // Don't store the offer URL as "original" if we somehow re-enter mid-swap
    var currentSrc = img.getAttribute('src') || img.src || '';
    var offerUrl = getConfigImageUrl();
    if (offerUrl && urlsMatch(currentSrc, offerUrl)) return;

    img.setAttribute(ORIG_SRC_ATTR, img.getAttribute('src') || '');
    img.setAttribute(ORIG_SRCSET_ATTR, img.getAttribute('srcset') || '');
    img.setAttribute(ORIG_SIZES_ATTR, img.getAttribute('sizes') || '');
  }

  function isOfferApplied(img, offerUrl) {
    if (!img || !offerUrl) return false;
    if (img.getAttribute(MARK_ATTR) !== 'true') return false;
    var src = img.getAttribute('src') || img.src || '';
    if (!urlsMatch(src, offerUrl)) return false;
    // srcset must be cleared or browser may keep serving the original
    var srcset = img.getAttribute('srcset') || img.srcset || '';
    return !srcset;
  }

  function applyOfferSrc(img, offerUrl) {
    if (!img || !offerUrl) return;
    if (isOfferApplied(img, offerUrl)) return;

    rememberOriginal(img);

    // Clear responsive sources first so `src` actually wins
    try {
      img.removeAttribute('srcset');
      img.srcset = '';
      img.removeAttribute('sizes');
      img.sizes = '';
    } catch (e) {}

    img.setAttribute('src', offerUrl);
    try {
      img.src = offerUrl;
    } catch (e2) {}

    if (!img.getAttribute('alt')) img.setAttribute('alt', ALT_TEXT);
    img.setAttribute(MARK_ATTR, 'true');
    img.setAttribute('loading', 'eager');
    try {
      img.setAttribute('fetchpriority', 'high');
    } catch (e3) {}
  }

  function restoreOriginal(img) {
    if (!img || !img.hasAttribute(ORIG_SRC_ATTR)) return;
    var src = img.getAttribute(ORIG_SRC_ATTR) || '';
    var srcset = img.getAttribute(ORIG_SRCSET_ATTR) || '';
    var sizes = img.getAttribute(ORIG_SIZES_ATTR) || '';
    if (src) {
      img.setAttribute('src', src);
      try {
        img.src = src;
      } catch (e) {}
    }
    if (srcset) {
      img.setAttribute('srcset', srcset);
      try {
        img.srcset = srcset;
      } catch (e2) {}
    } else {
      img.removeAttribute('srcset');
      try {
        img.srcset = '';
      } catch (e3) {}
    }
    if (sizes) img.setAttribute('sizes', sizes);
    else img.removeAttribute('sizes');
    img.removeAttribute(MARK_ATTR);
  }

  function getGalleries() {
    return document.querySelectorAll('product-gallery');
  }

  function getFirstMainImage(gallery) {
    if (!gallery) return null;
    var media = gallery.querySelector(
      '.product-gallery__media-list .product-gallery__media[data-media-type="image"]:not([hidden])'
    );
    if (!media) {
      media = gallery.querySelector(
        '.product-gallery__media-list .product-gallery__media[data-media-type="image"]'
      );
    }
    return media ? media.querySelector('img') : null;
  }

  function getFirstThumbnailImage(gallery) {
    if (!gallery) return null;
    var thumb = gallery.querySelector(
      '.product-gallery__thumbnail-list .product-gallery__thumbnail:not([hidden]) img'
    );
    if (!thumb) {
      thumb = gallery.querySelector('.product-gallery__thumbnail-list .product-gallery__thumbnail img');
    }
    return thumb || null;
  }

  function applyToGallery(gallery, active, offerUrl) {
    var mainImg = getFirstMainImage(gallery);
    var thumbImg = getFirstThumbnailImage(gallery);

    if (active && offerUrl) {
      applyOfferSrc(mainImg, offerUrl);
      applyOfferSrc(thumbImg, offerUrl);
    } else {
      restoreOriginal(mainImg);
      restoreOriginal(thumbImg);
    }
  }

  function gallerySwapSucceeded(offerUrl) {
    if (!offerUrl) return false;
    var galleries = getGalleries();
    if (!galleries.length) return false;
    var mainImg = getFirstMainImage(galleries[0]);
    return isOfferApplied(mainImg, offerUrl);
  }

  function getAccordionTitleText(details) {
    if (!details) return '';
    var summary = details.querySelector('summary');
    if (!summary) return '';
    return (summary.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function findAccordionDetailsByTitle(titleRe) {
    var nodes = document.querySelectorAll(
      '.product-info details.accordion, .accordion-group details.accordion, details.product-info__accordion, details.accordion, .product-info__liquid details'
    );
    for (var i = 0; i < nodes.length; i++) {
      if (titleRe.test(getAccordionTitleText(nodes[i]))) return nodes[i];
    }
    return null;
  }

  function findPackAccordionDetails() {
    return findAccordionDetailsByTitle(PACK_TITLE_RE);
  }

  function findWhatIsAccordionDetails() {
    return findAccordionDetailsByTitle(WHAT_IS_TITLE_RE);
  }

  function getAccordionMoveTarget(details) {
    if (!details) return null;
    return (
      details.closest('.product-info__block-item') ||
      details.closest('[data-block-type="collapsible-text"]') ||
      details.closest('.product-info__liquid') ||
      details
    );
  }

  function rememberAccordionPosition(item) {
    if (!item || item.hasAttribute(ORIG_POS_ATTR)) return;

    var next = item.nextElementSibling;
    var prev = item.previousElementSibling;
    var nextId = next && next.getAttribute('data-block-id');
    var prevId = prev && prev.getAttribute('data-block-id');

    item.setAttribute(ORIG_POS_ATTR, '1');
    if (nextId) item.setAttribute(ORIG_BEFORE_ATTR, nextId);
    if (prevId) item.setAttribute(ORIG_AFTER_ATTR, prevId);
  }

  function findBlockItemById(blockId) {
    if (!blockId) return null;
    return document.querySelector('.product-info__block-item[data-block-id="' + blockId + '"]');
  }

  function restoreAccordionPosition(item) {
    if (!item || !item.hasAttribute(ORIG_POS_ATTR)) return;

    var beforeId = item.getAttribute(ORIG_BEFORE_ATTR);
    var afterId = item.getAttribute(ORIG_AFTER_ATTR);
    var anchor;

    if (beforeId) {
      anchor = findBlockItemById(beforeId);
      if (anchor && anchor.parentElement) {
        anchor.parentElement.insertBefore(item, anchor);
        item.removeAttribute(ACCORDION_MOVED_ATTR);
        return;
      }
    }

    if (afterId) {
      anchor = findBlockItemById(afterId);
      if (anchor && anchor.parentElement) {
        if (anchor.nextElementSibling) {
          anchor.parentElement.insertBefore(item, anchor.nextElementSibling);
        } else {
          anchor.parentElement.appendChild(item);
        }
        item.removeAttribute(ACCORDION_MOVED_ATTR);
      }
    }
  }

  function setAccordionOpen(details, open) {
    if (!details) return;
    try {
      // Impact AccordionDisclosure uses a custom open setter
      details.open = !!open;
    } catch (e) {
      if (open) {
        details.setAttribute('open', '');
        details.setAttribute('aria-expanded', 'true');
      } else {
        details.removeAttribute('open');
        details.setAttribute('aria-expanded', 'false');
      }
    }
  }

  /**
   * Place "Que contient le pack Elios ?" where "Qu'est ce que ELIOS ?" sits (first),
   * because a liquid accordion sits between them and breaks accordion-group grouping.
   */
  function applyPackAccordion(active) {
    var packDetails = findPackAccordionDetails();
    if (!packDetails) return;

    var packItem = getAccordionMoveTarget(packDetails);
    if (!packItem) return;

    var whatDetails = findWhatIsAccordionDetails();
    var whatItem = getAccordionMoveTarget(whatDetails);

    if (active) {
      rememberAccordionPosition(packItem);

      if (whatItem && whatItem.parentElement) {
        // Insert pack in Qu'est ce que ELIOS ? ki jagah (us se pehle)
        if (packItem !== whatItem && packItem.nextElementSibling !== whatItem) {
          whatItem.parentElement.insertBefore(packItem, whatItem);
          packItem.setAttribute(ACCORDION_MOVED_ATTR, 'true');
        }
      } else if (packItem.parentElement && packItem.parentElement.firstElementChild !== packItem) {
        packItem.parentElement.insertBefore(packItem, packItem.parentElement.firstElementChild);
        packItem.setAttribute(ACCORDION_MOVED_ATTR, 'true');
      }

      setAccordionOpen(packDetails, true);
    } else {
      setAccordionOpen(packDetails, false);
      restoreAccordionPosition(packItem);
    }
  }

  function syncBodyClass(active) {
    var body = document.body;
    if (!body) return;
    body.classList.toggle(ACTIVE_CLASS, !!active);
  }

  function apply() {
    if (applying) {
      pendingApply = true;
      return;
    }
    applying = true;
    pendingApply = false;

    try {
      if (!isAllowedProductPage()) {
        syncBodyClass(false);
        return;
      }

      var offerUrl = getConfigImageUrl();
      var active = isSummerOfferActive();
      syncBodyClass(active);

      if (active && offerUrl) preloadOfferImage(offerUrl);

      var galleries = getGalleries();
      for (var i = 0; i < galleries.length; i++) {
        applyToGallery(galleries[i], active, offerUrl);
      }

      applyPackAccordion(active);
    } finally {
      applying = false;
      if (pendingApply) {
        pendingApply = false;
        scheduleApply();
      }
    }
  }

  function scheduleApply() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(apply, 40);
  }

  function startPolling() {
    var until = Date.now() + 12000;
    if (pollTimer) clearInterval(pollTimer);
    pollTimer = setInterval(function () {
      apply();

      var offerUrl = getConfigImageUrl();
      var active = isSummerOfferActive();
      var hasGallery = getGalleries().length && getFirstMainImage(getGalleries()[0]);
      var hasAccordion = !!findPackAccordionDetails();
      var swapOk = !active || gallerySwapSucceeded(offerUrl);

      // Keep polling until DOM is ready AND (if active) the offer image stuck
      if (Date.now() > until || (hasGallery && hasAccordion && swapOk)) {
        clearInterval(pollTimer);
        pollTimer = null;
        if (active) startVerifyLoop();
      }
    }, 200);
  }

  /** After initial apply, periodically re-check in case theme reverts src/srcset */
  function startVerifyLoop() {
    if (verifyTimer) clearInterval(verifyTimer);
    var until = Date.now() + 15000;
    verifyTimer = setInterval(function () {
      if (!isAllowedProductPage() || !isSummerOfferActive()) {
        clearInterval(verifyTimer);
        verifyTimer = null;
        return;
      }
      var offerUrl = getConfigImageUrl();
      if (!gallerySwapSucceeded(offerUrl)) {
        apply();
      }
      if (Date.now() > until) {
        clearInterval(verifyTimer);
        verifyTimer = null;
      }
    }, 500);
  }

  function onProductLifecycleEvent() {
    scheduleApply();
    startPolling();
  }

  function init() {
    apply();
    startPolling();

    var observer = new MutationObserver(function (mutations) {
      if (applying) {
        pendingApply = true;
        return;
      }

      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        var target = m.target;

        if (m.type === 'attributes') {
          // A/B tool flipping body/html flag or class
          if (
            (m.attributeName === BODY_ATTR || m.attributeName === 'class') &&
            (target === document.body || target === document.documentElement)
          ) {
            scheduleApply();
            startPolling();
            return;
          }

          // Theme / lazy-loaders sometimes re-write src or srcset after our swap
          if (
            (m.attributeName === 'src' ||
              m.attributeName === 'srcset' ||
              m.attributeName === 'sizes') &&
            target &&
            target.tagName === 'IMG' &&
            target.closest &&
            target.closest('product-gallery')
          ) {
            scheduleApply();
            return;
          }
        }

        if (m.type === 'childList') {
          scheduleApply();
          return;
        }
      }
    });

    if (document.body) {
      observer.observe(document.body, {
        attributes: true,
        attributeFilter: [BODY_ATTR, 'class', 'src', 'srcset', 'sizes'],
        childList: true,
        subtree: true
      });
    }

    if (document.documentElement) {
      observer.observe(document.documentElement, {
        attributes: true,
        attributeFilter: [BODY_ATTR, 'class']
      });
    }

    document.addEventListener('product:rerender', onProductLifecycleEvent);
    document.addEventListener('variant:change', onProductLifecycleEvent);
    document.addEventListener('shopify:section:load', onProductLifecycleEvent);
    window.addEventListener('pageshow', onProductLifecycleEvent);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
